import $ from 'jquery';
import Swiper, {
    Navigation,
    Autoplay,
    EffectFade
} from 'swiper/core';

Swiper.use([Navigation, Autoplay, EffectFade]);
class HeroSlide {
    constructor() {
        this.init();
    }

    init() {
        var getTimeout = function () {
            var e = setTimeout,
                b = {};
            setTimeout = function (a, c) {
                var d = e(a, c);
                b[d] = [Date.now(), c];
                return d
            };
            return function (a) {
                return (a = b[a]) ? Math.max(a[1] - Date.now() + a[0], 0) : NaN
            }
        }();

        function sanitisePercentage(i) {
            return Math.min(100, Math.max(0, i));
        }

        // Slider
        var percentTime,
            tick,
            heroContent,
            mySwiper,
            progressBar = document.querySelectorAll('.hero__progress-indicator');

        heroContent = new Swiper('#here-content', {
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            loop: true,
            speed: 800,
            slidesPerView: 1,
            autoHeight: true,
            allowTouchMove: false,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false
            },
            watchSlidesVisibility: true,
            watchSlidesProgress: true
        });

        mySwiper = new Swiper('#hero-banner', {
            effect: 'slide',
            loop: true,
            speed: 800,
            slidesPerView: 1,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false
            },
            thumbs: {
                swiper: heroContent
            },
            on: {
                afterInit: function() {
                    $('.hero__content').addClass('hero__content--visible');
                },

                slideChange: function () {
                    var swiper = this;
                    var defaultSlideDelay = swiper.params.autoplay.delay;
                    var currentIndex = swiper.realIndex;
                    var currentSlide = swiper.slides[currentIndex];
                    var currentSlideDelay = currentSlide.getAttribute('data-swiper-autoplay') || defaultSlideDelay;
                    updateSwiperProgressBar(progressBar[currentIndex], currentSlideDelay);
                }
            }
        });

        function updateSwiperProgressBar(bar, slideDelay) {

            function startProgressBar() {
                resetProgressBar();
                tick = setInterval(progress, 50);
            }

            function progress() {

                var timeLeft = getTimeout(mySwiper.autoplay.timeout);

                if (mySwiper.autoplay.running && !mySwiper.autoplay.paused) {
                    percentTime = sanitisePercentage(100 - Math.round(timeLeft / slideDelay * 100));
                    bar.style.width = percentTime + '%';

                    if (percentTime > 100) {
                        resetProgressBar();
                    }
                }

                if (mySwiper.autoplay.paused) {
                    percentTime = 0;
                    bar.style.width = 0;
                }
            }

            function resetProgressBar() {
                percentTime = 0;
                //bar.style.width = 0;
                progressBar.forEach((element, index) => {
                    setTimeout(function () {
                        progressBar[index].style = 0;
                    }, 50)
                });
                clearInterval(tick);
            }

            startProgressBar();

        }

        $('.hero__progress-item').each((i, el) => {
            $(el).on('click', () => {
                mySwiper.slideToLoop(i)
                heroContent.slideToLoop(i)
            })
        })
    }

}
export default HeroSlide;